import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import './verify/contract';
import './lib/devtools';
import { initSentry } from './instrument';
import App from './App';
import { registrarSW, esChunkError, recuperarDeChunkError } from './lib/appUpdate';

initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// iOS puede vaciar IndexedDB con poco espacio y ahí está la cola offline sin sincronizar.
// Pedimos almacenamiento persistente al arrancar (no bloquea nada si el navegador lo deniega).
if (navigator.storage && navigator.storage.persist) {
  navigator.storage.persisted().then((ya) => { if (!ya) navigator.storage.persist().catch(() => {}); }).catch(() => {});
}

// Red de seguridad global: cualquier fallo de carga de chunk fuera de React (import diferido,
// prefetch, manejador de evento) dispara la recuperación automática (desregistra SW + limpia caché + recarga).
window.addEventListener('unhandledrejection', (e) => { if (esChunkError(e)) recuperarDeChunkError(); });
window.addEventListener('error', (e) => { if (esChunkError(e)) recuperarDeChunkError(); });

registrarSW();
